import React from "react";
import {
    UserGraduationPercentage,
    RangeInputSelectedValue,
} from "../../../../containers/RegistrationLoginPage/types";
import RangeInput from "../../../RangeInput";
import {Field} from "react-final-form";
import {
    composeValidators,
    regRequiredValidate,
    numberValidation,
    regNumberValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";

interface GraduationPercentageInterface {
    configuration: UserGraduationPercentage;
}

const GraduationPercentage: React.FC<GraduationPercentageInterface> = ({
    configuration,
}: GraduationPercentageInterface) => {
    const {editable, values, selectedValue, fieldName} = configuration;

    return (
        <Field<RangeInputSelectedValue>
            name={fieldName}
            validate={composeValidators(
                regRequiredValidate("Please move slider to select graduation percentage"),
                regNumberValidate("Invalid graduation percentage"),
                numberValidation(values?.min, values?.max, values?.step),
            )}
            initialValue={selectedValue}
            validateFields={[]}
        >
            {(props) => {
                return (
                    <RangeInput
                        heading="Graduation Percentage"
                        editable={editable}
                        values={values}
                        type="Percentage"
                        isFocused={props.meta.active}
                        isTouched={props.meta.touched}
                        isError={errorHandler(props?.meta)}
                        initialValue={props.input.value}
                        inputRFF={props.input}
                    />
                );
            }}
        </Field>
    );
};

export default GraduationPercentage;
